/** OAuth consent handles must not reach analytics or error-report routes. */
export function isMcpConsentPath(path: string): boolean {
  return /^\/ai-koppeling\//i.test(path);
}

export function redactMcpConsentRoute(path: string): string {
  return isMcpConsentPath(path) ? "/ai-koppeling/[REDACTED]" : path;
}

// Keep the whole login/consent document free of tracking, including when the
// router temporarily redirects an unauthenticated user to /login.
export const isMcpConsentDocument =
  typeof window !== "undefined" && isMcpConsentPath(window.location.pathname);
